import { getSignal } from '@api/index';
import { ReactNode } from 'react';

import { EntityType } from '../features/foresightedDriving/types';
import { Driver, HydratedEntity, SignalValue, Vehicle } from '../types';

export type ColumnValue = string | SignalValue | Date | Vehicle[] | Driver[] | (Vehicle & { shouldShowFuelType: boolean })[];

export type Column = {
    key: string;
    type?: string;
    unit?: string;
    dataField: string;
    labelId: string;
    valueExtractor: (entity: any) => any;
    formatter: (value: any, data?: any) => ReactNode;
    dataSort: boolean;
    icon?: string;
    width?: string;
    hideLabelOnTable?: boolean;
};

type ColumnTemplate = Omit<Column, 'dataSort' | 'valueExtractor'> &
    Partial<Pick<Column, 'dataSort' | 'valueExtractor'>>;

type RatioColumnTemplate = Omit<Column, 'dataSort' | 'valueExtractor' | 'dataField'> & {
    leftDataField: string;
    rightDataField: string;
};

export type RatioColumn = Column & {
    rightDataField: string;
};

export default function createColumn({
    key,
    type,
    unit,
    dataField,
    labelId,
    valueExtractor,
    formatter,
    dataSort,
    icon,
    width,
    hideLabelOnTable,
}: ColumnTemplate): Column {
    return {
        key,
        type,
        unit,
        dataField,
        labelId,
        valueExtractor:
            valueExtractor ||
            ((entity: HydratedEntity | EntityType) =>
                (getSignal(entity, dataField, undefined) as never) as ColumnValue),
        formatter,
        dataSort: dataSort === undefined ? true : dataSort,
        icon,
        width,
        hideLabelOnTable,
    };
}

export function createRatioColumn({
    key,
    unit,
    leftDataField,
    rightDataField,
    labelId,
    formatter,
}: RatioColumnTemplate): RatioColumn {
    return {
        key,
        unit,
        dataField: leftDataField,
        rightDataField,
        labelId,
        valueExtractor: (entity: HydratedEntity | EntityType) =>
            ([
                getSignal(entity, leftDataField, undefined),
                getSignal(entity, rightDataField, undefined),
            ] as never) as ColumnValue,
        formatter,
        dataSort: true,
    };
}
